var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        scrollable: "",
        "max-height": "auto",
        "max-width":
          _vm.$vuetify.breakpoint.name == "xs" ||
          _vm.$vuetify.breakpoint.name == "sm"
            ? "90%"
            : "50%",
        persistent: "",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "mx-auto elevation-0 overflow-y-auto",
          attrs: { outlined: "", height: "80vh", prominent: "" },
        },
        [
          _c(
            "v-card-title",
            { staticClass: "ma-0 pa-0" },
            [
              _c(
                "v-app-bar",
                {
                  staticClass: "mb-0 elevation-1",
                  attrs: { dense: "", height: "45" },
                },
                [
                  _c("v-toolbar-title", { staticClass: "subtitle-1" }, [
                    _c("span", { staticClass: "mb-0" }, [
                      _vm.selectAllFiltered
                        ? _c("span", [
                            _vm._v(
                              "(" +
                                _vm._s(_vm.effectiveSelectedCount) +
                                ") Professores do filtro selecionados"
                            ),
                          ])
                        : _c("span", [
                            _vm._v(
                              "(" +
                                _vm._s(_vm.selected.length) +
                                ") Professor(es) selecionado(s)"
                            ),
                          ]),
                    ]),
                  ]),
                  _c("v-spacer"),
                  _c("emc-button-icon", {
                    attrs: {
                      icon: "mdi-refresh",
                      text: "Atualizar",
                      color: "success",
                      loading: _vm.loadingRefresh,
                      disabled: _vm.loadingSaving,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.getItems(true)
                      },
                    },
                  }),
                  _vm.totalPages > 1
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            attrs: {
                                              disabled:
                                                !_vm.selectAllFiltered &&
                                                _vm.selected.length === 0,
                                              icon: "",
                                            },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.clearFilter()
                                              },
                                            },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              color: "primary lighten-2",
                                            },
                                          },
                                          [_vm._v("mdi-playlist-remove")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3189379580
                          ),
                        },
                        [
                          _c("span", [
                            _vm._v("Limpar todos items selecionados"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: { icon: "" },
                                      nativeOn: {
                                        click: function ($event) {
                                          _vm.dialog = false
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "red lighten-2" } },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [_c("span", [_vm._v("Fechar")])]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticClass: "pt-2" },
            [
              _c(
                "v-container",
                [
                  _c(
                    "v-row",
                    { staticClass: "mb-0" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("sys-select-term", {
                            attrs: {
                              model: _vm.term_id,
                              label: "Termo",
                              dense: "",
                              outlined: "",
                              disabled: _vm.loadingSaving,
                            },
                            on: {
                              "update:model": function ($event) {
                                _vm.term_id = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("sys-select-company", {
                            attrs: {
                              model: _vm.companyIds,
                              label: "Empresa",
                              dense: "",
                              outlined: "",
                              clearable: "",
                              multiple: "",
                              disabled: _vm.loadingSaving,
                            },
                            on: {
                              "update:model": function ($event) {
                                _vm.companyIds = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mb-0" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("sys-select-campus", {
                            attrs: {
                              model: _vm.campusIds,
                              educationalGroupId: _vm.educationalGroupId,
                              label: "Campus",
                              dense: "",
                              outlined: "",
                              clearable: "",
                              multiple: "",
                              "filter-relation": "groups",
                              "return-object": false,
                              disabled: _vm.loadingSaving,
                            },
                            on: {
                              "update:model": function ($event) {
                                _vm.campusIds = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("sys-select-course", {
                            attrs: {
                              model: _vm.courseIds,
                              campusId: _vm.campusIdsForCourse,
                              label: "Curso",
                              dense: "",
                              outlined: "",
                              clearable: "",
                              multiple: "",
                              "return-object": false,
                              filter: "",
                              disabled: _vm.loadingSaving,
                            },
                            on: {
                              "update:model": function ($event) {
                                _vm.courseIds = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mb-0" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("SelectVariationStatus", {
                            attrs: {
                              label: "Status de Variação",
                              outlined: "",
                              dense: "",
                              "load-data": "",
                              clearable: "",
                              disabled: _vm.loadingSaving,
                            },
                            model: {
                              value: _vm.workLoadVariationStatus,
                              callback: function ($$v) {
                                _vm.workLoadVariationStatus = $$v
                              },
                              expression: "workLoadVariationStatus",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("sys-select-teacher-position", {
                            attrs: {
                              model: _vm.teacherPositionIds,
                              label: "Cargo",
                              multiple: "",
                              dense: "",
                              outlined: "",
                              clearable: "",
                              "select-all": "",
                              filterRelation: "contracts",
                            },
                            on: {
                              "update:model": function ($event) {
                                _vm.teacherPositionIds = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mt-0" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pt-0",
                          attrs: { cols: "12", sm: "12" },
                        },
                        [
                          _c("v-text-field", {
                            staticClass: "mb-2",
                            attrs: {
                              label: "Buscar professor por nome",
                              "prepend-inner-icon": "mdi-magnify",
                              clearable: "",
                              dense: "",
                              outlined: "",
                              "hide-details": "",
                              disabled: _vm.loadingSaving,
                            },
                            on: { input: _vm.onSearchInput },
                            model: {
                              value: _vm.search,
                              callback: function ($$v) {
                                _vm.search = $$v
                              },
                              expression: "search",
                            },
                          }),
                          _c(
                            "v-list",
                            { staticClass: "pa-0 ma-0", attrs: { dense: "" } },
                            [
                              _c(
                                "v-list-item-group",
                                {
                                  attrs: { color: "primary" },
                                  model: {
                                    value: _vm.selectedTeacher,
                                    callback: function ($$v) {
                                      _vm.selectedTeacher = $$v
                                    },
                                    expression: "selectedTeacher",
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item",
                                    {
                                      attrs: { ripple: "" },
                                      on: {
                                        mousedown: function ($event) {
                                          $event.preventDefault()
                                        },
                                        click: _vm.toggle,
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-action",
                                        [
                                          _vm.items.length
                                            ? _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    color:
                                                      _vm.selectAllFiltered ||
                                                      _vm.selected.length > 0
                                                        ? "indigo darken-4"
                                                        : "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " + _vm._s(_vm.icon) + " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.selectAllLabel) +
                                                " "
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("v-divider"),
                                  _vm.loading
                                    ? _c("v-progress-linear", {
                                        attrs: {
                                          indeterminate: "",
                                          color: "yellow darken-2",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.loadingSaving
                                    ? _c(
                                        "v-card",
                                        {
                                          staticClass: "mt-2",
                                          attrs: { outlined: "" },
                                        },
                                        [
                                          _c(
                                            "v-card-text",
                                            { staticClass: "py-2" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-center justify-space-between",
                                                },
                                                [
                                                  _c("div", [
                                                    _vm._v(
                                                      " Gerando " +
                                                        _vm._s(
                                                          _vm.generateProgress
                                                            .processed
                                                        ) +
                                                        " de " +
                                                        _vm._s(
                                                          _vm.generateProgress
                                                            .total
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        text: "",
                                                        color: "error",
                                                        disabled:
                                                          _vm.cancelGenerate,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          $event.stopPropagation()
                                                          _vm.cancelGenerate = true
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" Cancelar ")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c("v-progress-linear", {
                                                attrs: {
                                                  value:
                                                    _vm.generateProgressPercent,
                                                  height: "10",
                                                  rounded: "",
                                                  color: "amber darken-1",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "emc-util-scroll",
                                    { attrs: { height: "40vh" } },
                                    _vm._l(_vm.items, function (item, index) {
                                      return _c(
                                        "v-list-item",
                                        {
                                          key: index,
                                          on: {
                                            mousedown: function ($event) {
                                              $event.preventDefault()
                                            },
                                            click: function ($event) {
                                              return _vm.selectTeacher(index)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            [
                                              _c("v-icon", {
                                                attrs: {
                                                  color: _vm.isCheckedTeacher(
                                                    index
                                                  )
                                                    ? "indigo darken-4"
                                                    : "",
                                                },
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.isCheckedTeacher(index)
                                                      ? "mdi-checkbox-marked-outline"
                                                      : "mdi-checkbox-blank-outline"
                                                  ),
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c("v-list-item-title", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    item.name
                                                  ),
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c(
                "v-container",
                [
                  _c(
                    "v-row",
                    { staticClass: "mb-2", attrs: { align: "center" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex align-center",
                          attrs: { cols: "12", sm: "6" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "amber darken-1",
                                disabled: _vm.disableButton,
                                loading: _vm.loadingSaving,
                                depressed: "",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.generate()
                                },
                              },
                            },
                            [_vm._v(" Gerar ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-end",
                          attrs: { cols: "12", sm: "6" },
                        },
                        [
                          _c("v-pagination", {
                            staticClass: "my-0",
                            attrs: {
                              disabled: _vm.loadingSaving,
                              length: _vm.totalPages,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.pagination()
                              },
                            },
                            model: {
                              value: _vm.page,
                              callback: function ($$v) {
                                _vm.page = $$v
                              },
                              expression: "page",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "520", persistent: "" },
          model: {
            value: _vm.confirmDialog.show,
            callback: function ($$v) {
              _vm.$set(_vm.confirmDialog, "show", $$v)
            },
            expression: "confirmDialog.show",
          },
        },
        [
          _c(
            "v-card",
            { attrs: { outlined: "" } },
            [
              _c("v-card-title", { staticClass: "subtitle-1" }, [
                _vm._v(_vm._s(_vm.confirmDialog.title)),
              ]),
              _c("v-card-text", [_vm._v(_vm._s(_vm.confirmDialog.text))]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.resolveConfirm(false)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.confirmDialog.cancelLabel))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "amber darken-1", depressed: "" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.resolveConfirm(true)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.confirmDialog.confirmLabel))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: {
            color: _vm.snackbar.color,
            timeout: _vm.snackbar.timeout,
            top: "",
          },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function ({ attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { text: "" },
                        on: {
                          click: function ($event) {
                            _vm.snackbar.show = false
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v("Fechar")]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.snackbar.show,
            callback: function ($$v) {
              _vm.$set(_vm.snackbar, "show", $$v)
            },
            expression: "snackbar.show",
          },
        },
        [_vm._v(" " + _vm._s(_vm.snackbar.message) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }